import { gql } from '../types/generated';

export const GET_BTC_SCHEDULE = gql(`
  query btcSchedule($date: String = "", $sports: [Sport] = [MLB]) {
    schedule(date: $date, sports: $sports) {
      ...BTCGameFields
    }
  }
`);

export const BTC_GAME = gql(`
  query btcGame($gamePk: Int!, $scheduleDate: String) {
    game(gamePk: $gamePk, scheduleDate: $scheduleDate) {
      ...BTCGameFields
    }
  }
`);

export const BTC_GAME_PIPELINE = gql(`
  query btcGamePipelines($gamePk: Int!, $scheduleDate: String) {
    game(gamePk: $gamePk, scheduleDate: $scheduleDate) {
      gamePk
      pipelines {
        ...BTCPipelineFields
      }
    }
  }
`);

export const BTC_GAME_CONTENT = gql(`
  query btcGameContent($gamePk: Int!, $scheduleDate: String) {
    game(gamePk: $gamePk, scheduleDate: $scheduleDate) {
      gamePk
      content {
        ...BTCContentFields
      }
    }
  }
`);

export const BTC_GAME_CONTENT_WITH_ASSETS = gql(`
  query btcGameContentWithAssets($gamePk: Int!, $scheduleDate: String) {
    game(gamePk: $gamePk, scheduleDate: $scheduleDate) {
      gamePk
      content {
        ...BTCContentAssetsFields
      }
    }
  }
`);

export const SEARCH_MULTICAST_MAPPING = gql(`
  query searchMulticastMapping($callSign: String, $priority: String, $sourceLocations: String) {
    searchMulticastMappings(callSign: $callSign, priority: $priority, sourceLocation: $sourceLocations) {
      ...MulticastMappingFields
    }
  }
`);

export const EVI_PODS = gql(`
  query eviPods {
    eviPods {
      id
      name
      vendor
      active
    }
  }
`);

export const COPYRIGHT_STREAMS = gql(`
  query copyrightStreams($gamePk: Int!, $scheduleDate: String!) {
    copyrightStreams(gamePk: $gamePk, scheduleDate: $scheduleDate) {
      ...CopyrightStreamFields
    }
  }
`);

export const GET_PLAYBACK_CDNS = gql(`
  query playbackCdns {
    playbackCdns {
      cdn
      enabled
    }
  }
`);

export const GET_BROADCAST_SOURCE_OVERRIDES = gql(`
  query broadcastSourceOverrides {
    broadcastSourceOverrides {
      id
      callSign
      pregameSource
      gameSource
      postgameSource
    }
  }
`);

export const GET_BROADCAST_ACQUISITIONS = gql(`
  query broadcastAcquisitions($gamePk: Int!, $feedTypeCode: String!) {
    broadcastAcquisitions(gamePk: $gamePk, feedTypeCode: $feedTypeCode) {
      callSign
      defaults {
        decoderInputLabel
        multicastAddress
        host
        region
        priority
      }
      overrides {
        id
        region
        callSign
        fronthaulDecoderInputLabel
        multicastAddress
      }
    }
  }
`);

export const GET_ZIXI_SOURCES_BY_TEAM = gql(`
  query searchZixiSourcesByTeam($teamId: Int, $location: String, $destination: String, $activeSource: String) {
    searchZixiSourcesByTeam(teamId: $teamId, location: $location, destination: $destination, activeSource: $activeSource) {
      zixiSourceName
      teamId
      location
      destination
      activeSource
    }
  }
`);

export const SKYVIEW_CONFIGS = gql(`
  query skyviewConfigs {
    skyviewConfigs {
      teamId
      language
      enabled
    }
  }
`);
